<template>
  <div>
    <div :class="steps == 1 ? 'none-steps' : 'steps-box'">
      <div
        v-for="i in steps"
        :key="i"
        :class="{ done: current >= i }"
        class="steps"
      ></div>
    </div>
    <!-- Passos -->
    <step-item :steps="getSteps()" :current="current"></step-item>

    <div v-if="!hideButtons" class="text-center mt_15">
      <base-button
        :design="'two'"
        :text="prevBtnText"
        class="mr_5"
        @click.native.prevent="prev"
        :disabled="current == 1"
      />
      <base-button
        :text="nextBtnText"
        class="ml_5"
        @click.native.prevent="next"
      />
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import StepItem from "./StepItem";
import BaseButton from "@/components/Button";

export default {
  data() {
    return {
      steps: 0,
      current: 1,
    };
  },
  props: {
    hideButtons: { type: Boolean, default: false },
    nextBtnText: { default: "Próximo" },
    prevBtnText: { default: "Anterior" },
    clear: {},
  },
  components: {
    BaseButton,
    StepItem,
  },
  methods: {
    prev() {
      this.current = Math.max(--this.current, 1);
      this.$emit("prev", this.current);
    },
    next() {
      if (this.current == this.steps) {
        this.$emit("finish");
      } else {
        this.current = Math.min(++this.current, this.steps);
        this.$emit("next", this.current);
      }
    },
    getSteps() {
      const availableSteps = this.$slots.default.filter(
        ({ data }) => !data || (data && data.class != "inactive")
      );
      this.steps = availableSteps.length;

      return availableSteps;
    },
  },
  watch: {
    clear() {
      this.current = 1;
    },
  },
};
</script>
<style scoped>
.steps-box {
  display: flex;
  margin: 0 -7px 30px -7px;
}
.steps {
  width: 100%;
  height: 6px;
  margin: 0 7px;
  background: var(--box-up);
  border-radius: 2px;
}
.steps.done {
  background: var(--default);
}
.none-steps {
  width: 0;
  height: 0;
  opacity: 0;
}
</style>